const cards = {
  CONNECT: "connect",
  FOLLOW: "follow",
  PETITION: "petition",
  SHARE: "share",
  ACT: "act",
};

export default cards;
